import React, { useEffect, useState } from "react";
import moment from "moment";
import { bindActionCreators, compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { RadioGroup, Radio, FormControlLabel } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { LabelText, LabelDollarFormatted } from "@loanbossinc/component-library";

import { actionCreators as dashboardActionCreators } from "../../dashboard/dashboard.store";
import { actionCreators as dscrLineItemActionCreators } from "./dscrLineItemManagement.store";
import { actionCreators as dscrCalculationActionCreators} from "../../reportingComponents/dscrCalculationDashboard/dscrRegularCalculationDashboard/dscrRegularCalculationDashboard.store";
import DscrTypesSelectionsValue from "./dscrTypesSelectionsValue";
import DscrTypesSelectionsComparison from "./dscrTypesSelectionsComparison";
import {
  HeaderContainer,
  ResultPreviewContainerHeader,
  ResultPreview,
  ResultPreviewLabelHeader,
  StyledButtonText,
  PreviewButtonResult,
  PreviewButtonContainer
} from "./styles";
import { DSCR_TYPE_NAMES, validateDscrInputs } from "./helpers";

const radioButtonsOptions = [
  { value: "value", label: "Value" },
  { value: "greaterOf", label: "Greater of" }
];

const DscrManagement = props => {
  const {
    lineItemType,
    resultValue,
    calculatedComparisonValue1,
    calculatedComparisonValue2,
    calculationFieldsInputValues,
    selectedDscrType,
    selectedComparisonType1,
    selectedComparisonType2,
    comparisonCalculationFieldsInputValues1,
    comparisonCalculationFieldsInputValues2,
    activeLoanId,
    isCalculating,
    recentAsOfDate,
    setDscrLineItemSelections,
    calculateMostRecentPayment,
    calculateRateReplacement,
    calculateProjectedCashflows,
    calculateTrailingCashflows,
    calculateHypotheticalAmortization,
    calculateMaxInterestPlusActualPrincipal,
    calculateFromField,
    fromFieldSelection,
    getMostRecentAsOfDateAmongRGI,
    getMostRecentProjectedAsOfDateAmongRGI,
    getReportGroupInstances,
    getProjectedReportGroupInstances,
    setDscrLineItemsToDefault,
    isProjected,
    reportGroupInstances,
    reportProjectedGroupInstances,
    setDraftAsOfDate,
    draftAsOfDate,
    match: {
      params: { reportId }
    }
  } = props;

  const [comparisonGroupToShowLoaderIn, setComparisonGroupToShowLoaderIn] = useState(null);
  useEffect(() => {
    if (!recentAsOfDate) {
      isProjected ? getMostRecentProjectedAsOfDateAmongRGI({ reportGroupId: reportId })
                  : getMostRecentAsOfDateAmongRGI({ reportGroupId: reportId });
    }

  }, [recentAsOfDate]);

  useEffect(() => {
    if (isProjected) {
      getProjectedReportGroupInstances({ reportGroupId: reportId });
    }
    else {
      getReportGroupInstances({ reportGroupId: reportId });
    }
  }, [reportId]);

    useEffect(() => {
    if(!(reportGroupInstances && reportProjectedGroupInstances))
    {
      return;
    }
    if (isProjected) {
      const draftProjected = reportGroupInstances.sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                            ?.find(rgi => rgi.isProjected === true);
      setDraftAsOfDate(draftProjected?.asOfDate);
    }
    else {
      const draft = reportGroupInstances.sort((a,b) => moment(b.updatedAt).valueOf() - moment(a.updatedAt).valueOf())
                                        ?.find(rgi => rgi.isDraft && !rgi.isProjected);
      setDraftAsOfDate(draft?.asOfDate);
    }
  }, [reportGroupInstances, reportProjectedGroupInstances]);

  useEffect(
    () => () => {
      setDscrLineItemsToDefault();
    },
    [setDscrLineItemsToDefault]
  );

  useEffect(() => {
    if (lineItemType === "value") {
      return;
    }
    if (calculatedComparisonValue1 !== null && calculatedComparisonValue2 !== null) {
      const result = calculatedComparisonValue1 >= calculatedComparisonValue2 ? calculatedComparisonValue1 : calculatedComparisonValue2;
      setDscrLineItemSelections({ resultValue: result });
    } else {
      setDscrLineItemSelections({ resultValue: null });
    }
  }, [lineItemType, calculatedComparisonValue1, calculatedComparisonValue2]);

  const handleRadioChange = e => setDscrLineItemSelections({
    lineItemType: e.target.value,
    resultValue: null,
    selectedDscrType: null,
    selectedComparisonType1: null,
    selectedComparisonType2: null
  });
  const floatingRateCalcMethodTypes = {
    reportInstanceAsOfDate: "Report instance as of date",
    paymentDateMinusLookback: "Payment date (minus the lookback)"
  };
  const isReadyToCalculateValue = () => calculationFieldsInputValues && validateDscrInputs(calculationFieldsInputValues, selectedDscrType.type);

  const getAsOfDateByfloatingRateCalcMethod = (floatingRateCalcMethod) =>
    !floatingRateCalcMethod || floatingRateCalcMethod === floatingRateCalcMethodTypes.reportInstanceAsOfDate ? recentAsOfDate : draftAsOfDate;

  const calculateDscrType = group => {
    let selectedType;
    let calculations;

    if (lineItemType === "value") {
      selectedType = selectedDscrType;
      calculations = calculationFieldsInputValues;
    } else {
      setComparisonGroupToShowLoaderIn(group);
      selectedType = group === "first" ? selectedComparisonType1 : selectedComparisonType2;
      calculations = group === "first" ? comparisonCalculationFieldsInputValues1 : comparisonCalculationFieldsInputValues2;
    }

    // eslint-disable-next-line default-case
    switch (selectedType.type) {
      case DSCR_TYPE_NAMES.MOST_RECENT_PAYMENT:
        calculateMostRecentPayment({ loanId: activeLoanId, group, asOfDate: recentAsOfDate });
        break;
      case DSCR_TYPE_NAMES.RATE_REPLACEMENT:
        {
          const cashflowsValues = calculations.find(calc => calc.fieldName === "cashflows");
          const periodsCovered = cashflowsValues.additionalInputValue.type;
          const periods = cashflowsValues.inputValue;

          const replacementRate = parseFloat(calculations.find(calc => calc.fieldName === "rate").inputValue, 10) / 100;

          calculateRateReplacement({ loanId: activeLoanId, asOfDate: recentAsOfDate, periodsCovered, periods, replacementRate, group });
        }
        break;
      case DSCR_TYPE_NAMES.ACTUAL_PROJECTED_CASHFLOWS:
        {
          const periods = calculations.find(calc => calc.fieldName === "Actual projected cashflows").inputValue;
          calculateProjectedCashflows({ loanId: activeLoanId, asOfDate: recentAsOfDate, periods, group });
        }
        break;
      case DSCR_TYPE_NAMES.ACTUAL_TRAILING_CASHFLOWS:
        {
          const periods = calculations.find(calc => calc.fieldName === "Actual trailing cashflows").inputValue;
          calculateTrailingCashflows({ loanId: activeLoanId, asOfDate: recentAsOfDate, periods, group });
        }
        break;
      case DSCR_TYPE_NAMES.HYPOTHETICAL_AMORTIZATION:
        {
          const periods = calculations.find(calc => calc.fieldName === "dscr amortization term").inputValue;
          const fixedRate = parseFloat(calculations.find(calc => calc.fieldName === "dscr fixed rate").inputValue, 10) / 100;
          const treasurySpread = parseFloat(calculations.find(calc => calc.fieldName === "dscr treasury spread").inputValue, 10) / 100;
          const floatingRateSpread = parseFloat(calculations.find(calc => calc.fieldName === "dscr floating rate spread").inputValue, 10) / 100;
          const dscrSwapRate = parseFloat(calculations.find(calc => calc.fieldName === "dscr swap rate").inputValue, 10) / 100;
          const floatingRateCalcMethod = calculations.find(calc => calc.fieldName === "index calculated on")?.additionalInputValue?.type;
          const loanBalanceType = calculations.find(calc => calc.fieldName === "loan balance")?.additionalInputValue?.type;
          const overrideRate = parseFloat(calculations.find(calc => calc.fieldName === "override hypothetical amortization rate?")?.inputValue, 10) / 100;

          calculateHypotheticalAmortization({
            loanId: activeLoanId,
            asOfDate: recentAsOfDate,
            periods,
            fixedRate: fixedRate || null,
            treasurySpread: treasurySpread || null,
            floatingRateSpread: floatingRateSpread || null,
            dscrSwapRate: dscrSwapRate || null,
            group,
            floatingRateMethod: floatingRateCalcMethod || null,
            loanBalanceType: loanBalanceType || null,
            overrideRate: overrideRate || null
          });
        }
        break;
        case DSCR_TYPE_NAMES.FROM_FILE:
        {
          const fieldValue = parseFloat(fromFieldSelection?.value ?? 0);
          calculateFromField({fieldValue});
        }
        break;
        case DSCR_TYPE_NAMES.MAX_INTEREST_PLUS_ACTUAL_PRINCIPAL:
        {
          const floatingRateSpread = parseFloat(calculations.find(calc => calc.fieldName === "dscr floating rate spread").inputValue, 10) / 100;
          const floatingRateCalcMethod = calculations.find(calc => calc.fieldName === "index calculated on")?.additionalInputValue?.type;
          calculateMaxInterestPlusActualPrincipal({
            loanId: activeLoanId,
            asOfDate: getAsOfDateByfloatingRateCalcMethod(floatingRateCalcMethod),
            floatingRateSpread: floatingRateSpread || null,
            group,
            floatingRateMethod: floatingRateCalcMethod || null
          });
        }
        break;
    }
  };

  return (
    <>
      <HeaderContainer>
        <RadioGroup value={lineItemType} aria-label="value-or-greaterOf" name="lineItemType" onChange={handleRadioChange}>
          {radioButtonsOptions.map(option => (
            <FormControlLabel key={option.value} value={option.value} control={<Radio />} label={<LabelText value={option.label} />} />
          ))}
        </RadioGroup>
        <ResultPreviewContainerHeader>
          <PreviewButtonResult>
            <PreviewButtonContainer>
              {selectedDscrType &&
                (selectedDscrType.type !== DSCR_TYPE_NAMES.MOST_RECENT_PAYMENT && selectedDscrType.type !== DSCR_TYPE_NAMES.FROM_FILE) &&
                lineItemType === "value" &&
                isReadyToCalculateValue() &&
                resultValue === null && <StyledButtonText reverse label="Preview" onClick={calculateDscrType} style={{ marginRight: "8px", height: "40px" }} />}
              {selectedDscrType &&
                (selectedDscrType.type !== DSCR_TYPE_NAMES.MOST_RECENT_PAYMENT && selectedDscrType.type !== DSCR_TYPE_NAMES.FROM_FILE) &&
                lineItemType === "value" &&
                isReadyToCalculateValue() &&
                resultValue !== null && <StyledButtonText reverse label="Recalculate" onClick={calculateDscrType} style={{ marginRight: "20px", height: "40px" }} />}
            </PreviewButtonContainer>

            <ResultPreview>
              {lineItemType === "value" && isCalculating ? (
                <CircularProgress size={20} style={{ color: "#005AA9" }} />
              ) : (
                <LabelDollarFormatted value={resultValue} decimals={2} />
              )}
            </ResultPreview>
          </PreviewButtonResult>
          <ResultPreviewLabelHeader>RESULT PREVIEW</ResultPreviewLabelHeader>
        </ResultPreviewContainerHeader>
      </HeaderContainer>
      {lineItemType === "value" ? (
        <DscrTypesSelectionsValue {...props} />
      ) : (
        <DscrTypesSelectionsComparison {...props} comparisonGroupToShowLoaderIn={comparisonGroupToShowLoaderIn} calculateDscrType={calculateDscrType} />
      )}
    </>
  );
};

const mapStateToProps = ({ lenderReportDscrLineItemManagement, lenderReportList, lenderReportsDscrCalculation: { activeLoanId } }) => ({
  ...lenderReportDscrLineItemManagement,
  ...lenderReportList,
  activeLoanId
});

const mapDispatchToProps = dispatch => bindActionCreators({ ...dscrLineItemActionCreators, ...dscrCalculationActionCreators, ...dashboardActionCreators }, dispatch);

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(DscrManagement);